<template>
  <div id='asset'>
    <p class="text-left mb-4 text-black">{{ getTranslation(title) }}</p>

    <div class="relative">
      <img v-if="url === ''"
           class="assetImage classen__rounded border-classen__secondary border cursor-pointer"
           src="../../assets/media/NoImage.png" alt="asset"/>
      <img v-else @click="$emit('onClick')" class="assetImage classen__rounded cursor-pointer"
           :src="url"
           alt="asset"/>
      <div @click="$emit('onClickDownload')"
           class="absolute right-0 cursor-pointer download bg-classen__primary">
        <img src="../../assets/icons/download.svg">
      </div>
    </div>
  </div>
</template>

<script>
import getTranslation from "../../mixins/getTranslation";

export default {
  name: "AssetDownload",

  mixins: [getTranslation],

  props: {
    title: {required: true},
    url: {required: true},
  },

  data() {
    return {}
  },

  created() {

  },

  destroyed() {

  },

  computed: {},

  watch: {},

  methods: {}
}
</script>
<style scoped>
.assetImage {
  width: 350px;
  height: 220px;
  object-fit: cover;
  float: right;
}

.download {
  width: 66px;
  height: 60px;
  line-height: 60px;
  border-radius: 0 0 50px 0;
  top: 160px;
  z-index: 50;
}

.download > img {
  width: 30px;
  height: 30px;
  margin-right: auto;
  margin-left: auto;
  margin-top: 15px;
}
</style>
